import { render, staticRenderFns } from "./crudOrdersReasonStockReserved.vue?vue&type=template&id=d28fc436"
import script from "./crudOrdersReasonStockReserved.vue?vue&type=script&lang=js"
export * from "./crudOrdersReasonStockReserved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports